let added = false;
let lastTouchTime = 0;
const className = 'useHover';

function onMouseMove() {
	if (Date.now() - lastTouchTime >= 500) {
		document.body.classList.add(className);
	}
}
function onTouchStart() {
	document.body.classList.remove(className);
	lastTouchTime = Date.now();
}

function remove() {
	window.removeEventListener('mousemove', onMouseMove, true);
	window.removeEventListener('touchstart', onTouchStart, true);
	document.body.classList.remove(className);
}

export default function() {
	if (added) {
		return;
	}
	window.addEventListener('mousemove', onMouseMove, true);
	window.addEventListener('touchstart', onTouchStart, true);
	document.body.classList.add(className);
	return { remove };
}
